export default __webpack_public_path__ + "static/media/thumb_up.0b01f30a.svg";